import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, pairwise, Subscription, switchMap, takeUntil } from 'rxjs';
import { LoggerService } from '../providers/logger.service';
import { TwfstyleService } from '../providers/twfstyle.service';

@Component({
  selector: 'app-pen-marker',
  template: `
    <canvas #canvas [ngClass]="{'selected-element': element.selected && pageElement, 'abx-element': pageElement === true}"></canvas>
  `,
  styles: [
  ]
})
export class PenMarkerComponent implements OnInit, AfterViewInit, OnChanges {
  //@ViewChild('canvas') public canvas: ElementRef | undefined;
  @ViewChild("canvas", { static: false }) canvas: ElementRef;
  canvasEl: any;

  @Input() element: any;
  @Input() pageElement: any;
  @Input() draggable: boolean;
  @Input() canvasClass: any;
  @Input() pageModified: boolean;
  @Input() pageModifiedPosition: boolean = false;
  @Input() selected: boolean;
  
  @Input() maxWidth: any;
  @Input() maxHeight: any;
  @Input() styleChanged: boolean;

  @Output() pageModifiedReset: EventEmitter<boolean> = new EventEmitter();

  constructor(private twfStyle: TwfstyleService,
    private logger: LoggerService,
    private cdref: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.canvasEl = this.canvas.nativeElement as HTMLCanvasElement;
    if (this.pageElement === false) {
      this.element.selected = false;
    }

    this.drawPenMarker(this.element);
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (this.pageElement === false) {
        this.element.selected = false;
      }

      if (this.element.selected === true) {
        this.drawPenMarker(this.element);
      }
    } catch (e) {
      this.logger.logInternalError("PenMarkerComponent: $onChanges", e.message);
    }
  }

  drawPenMarker(el) {
    try {
      if (el === undefined) return;
      if (this.canvas === undefined) return;

      this.offsetPenMarker(el);

      var ctx = this.canvasEl.getContext("2d");

      if (this.maxWidth) {
        if (el.width * el.scaleX > this.maxWidth) {
          el.scaleX = this.maxWidth / el.width;
          el.scaleY = el.scaleX;
        }
      }
      if (this.maxHeight) {
        if (el.height * el.scaleY > this.maxHeight) {
          el.scaleY = this.maxHeight / el.height;
          el.scaleX = el.scaleY;
        }
      }

      ctx.canvas.width = el.width * el.scaleX;
      ctx.canvas.height = el.height * el.scaleY;

      ctx.strokeStyle = this.twfStyle.toCssColor(el.inkColor);
      ctx.lineWidth = Math.floor(el.inkSize * el.scaleX);
      ctx.lineCap = "square";
      ctx.lineJoin = "round";
      ctx.beginPath();

      var prevP2x, prevP2y;

      for (var j = 0; j < el.bezierInts.length; j += 8) {
        var p1x = el.bezierInts[j] * el.scaleX;
        var p1y = el.bezierInts[j + 1] * el.scaleY;
        var c1x = el.bezierInts[j + 2] * el.scaleX;
        var c1y = el.bezierInts[j + 3] * el.scaleY;
        var c2x = el.bezierInts[j + 4] * el.scaleX;
        var c2y = el.bezierInts[j + 5] * el.scaleY;
        var p2x = el.bezierInts[j + 6] * el.scaleX;
        var p2y = el.bezierInts[j + 7] * el.scaleY;

        if (j === 0)
          ctx.moveTo(p1x, p1y);
        else if (prevP2x !== p1x || prevP2y !== p1y)
          ctx.moveTo(p1x, p1y);

        ctx.bezierCurveTo(c1x, c1y, c2x, c2y, p2x, p2y);
        prevP2x = p2x;
        prevP2y = p2y;
      } 

      ctx.stroke();
      var elx;
      var ely;

      if (this.pageElement) {
        this.canvasEl.style.position = "absolute";
        this.canvasEl.style.left = el.x + "px";
        this.canvasEl.style.top = el.y + "px";

        if (this.pageModified === true) this.pageModifiedReset.emit(false);
        this.cdref.detectChanges();
      }
    } catch (e) {
      this.logger.logInternalError("MARKER: draw", e.message);
    }
  }

  scalePenMarker(el) {

    try {
      for (var i = 0; i < el.bezierInts.length; i += 2) {
        el.bezierInts[i] = Math.floor(el.bezierInts[i] * el.scaleX);
        el.bezierInts[i + 1] = Math.floor(el.bezierInts[i + 1] * el.scaleY);
      }

      el.inkSize = Math.round(el.inkSize * el.scaleX);
      el.scaleX = 1.0;
      el.scaleY = 1.0;
    } catch (e) {
      this.logger.logInternalError("ERASER: scale", e.message);
    }
  }

  offsetPenMarker(el) {

    try {
      var minX = Number.MAX_VALUE;
      var minY = Number.MAX_VALUE;
      var maxX = 0;
      var maxY = 0;
      var i;
      var j;

      for (j = 0; j < el.bezierInts.length; j += 8) {
        var p1x = el.bezierInts[j];
        var p1y = el.bezierInts[j + 1];
        var p2x = el.bezierInts[j + 6];
        var p2y = el.bezierInts[j + 7];

        minX = Math.min(minX, p1x - el.inkSize);
        minX = Math.min(minX, p2x - el.inkSize);
        minY = Math.min(minY, p1y - el.inkSize);
        minY = Math.min(minY, p2y - el.inkSize);

        maxX = Math.max(maxX, p1x + el.inkSize);
        maxX = Math.max(maxX, p2x + el.inkSize);
        maxY = Math.max(maxY, p1y + el.inkSize);
        maxY = Math.max(maxY, p2y + el.inkSize);
      }

      for (j = 0; j < el.bezierInts.length; j += 2) {
        el.bezierInts[j] -= minX;
        el.bezierInts[j + 1] -= minY;
      }

      el.x += minX;
      el.y += minY;
      el.width = (maxX - minX);
      el.height = (maxY - minY);

      // Scale elements which are not in
      if (!this.pageElement && el.scaleY === 1) {
        el.scaleY = 150.0 / el.height;
        el.scaleX = el.scaleY;
      }
    } catch (e) {
      this.logger.logInternalError("ERASER: offset", e.message);
    }
  }

  isMouseDown: boolean = false;
  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event) {
    this.isMouseDown = false;
  }

  @HostListener('window:mousedown', ['$event'])
  onMouseDown(event) {
    this.isMouseDown = true;
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event) {
    if (this.isMouseDown) {
      //if (this.pageElement) {
      //  this.canvasEl.style.position = "absolute";
      //  this.canvasEl.style.left = this.element.x + "px";
      //  this.canvasEl.style.top = this.element.y + "px";
      //}
    }
  }

}
